module.exports = __webpack_public_path__ + "img/telephone-fill.0d092770.svg";